export default {
  calendar: {
    today: 'Heute',
    tomorrow: 'Morgen',
    asap: 'ASAP',
  },
};
